import React from 'react'
import cover from './../assets/cover.jpg'
import me from './../assets/me.jpg'

import personalInfomation from "../assets/json/personalInfomation.json"

export default class Cover extends React.Component {
  render () {
    const bannerStyle = {
      height: '100%',
      width: '100%',
      backgroundPosition: 'center bottom',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      backgroundImage: `url(${cover})`
    };

    return (
      <section className="hero" style={bannerStyle} id={ this.props.id }>
        <div className="hero-body" style={{ backgroundColor: 'rgba(255,255,255,.35)' }}>
          <div className="container is-flex-desktop">
            <div className="control wrapper-cover-profile">
              <figure className="image is-128x128 cover-profile">
                <img src={me} alt="cover" />
              </figure>
            </div>
            <div className="control">
              <h1 className="title is-2 has-text-black-bis">{personalInfomation.full_name}</h1>
              <h1 className="subtitle is-4 has-text-black-bis" style={{ marginBottom: 0 }}>{personalInfomation.job_title}</h1>
              <div className="subtitle is-6 has-text-black-bis">
                <span className="icon is-medium">
                  <i className="fas fa-graduation-cap"></i>
                </span>
                {`${personalInfomation.current_degree_info.degree}, ${personalInfomation.current_degree_info.institute}`}
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }
}